export const jobsData = [
  {
    name: "5 Frontend Dev (ReactJS, Javascript, C#)",
    img: "/img/Jobs/1.png",
    tech: ["JavaScript", "NodeJS", "ReactJS"],
    address: "86-88 Dinh Tien Hoang, Binh Thanh, Ho Chi Minh",
    location: "HCM",
    time: "2 hours ago",
    reasons: [
      "Attractive salary -Up to 1500$",
      "American-Based Company",
      "Premium health insurance.",
    ],
    description:
      "We are an American based company who looking to add Front-End Engineers to our team on a Full-Time basis. We are interested in developing software products with adapting latest technologies and methodologies of software development. Some of tools we are currently using: Cloud services, Kubernetes, ReactJS, Vuejs,  Nodejs, .Net core 2.0, .Net 4.7,  SQL Server 2017, and  RabbitMQ. ",
    experience: [
      "A bachelor’s degree in a technical discipline or equivalent experience in IT industry.",
      "High level of experience with ReactJS and MongoDB",
      "Knowledge of the .NET Framework and C# is beneficial.",
      "Have experience with any kind of front-end unit testing (jest, jasmine, mocha, karma)",
      "Comfortable working in a fast-paced environment",
      "Good teamwork spirit and logical thinking",
    ],
    why: [
      "Located in the center of HCMC",
      "Stable and long-term career path",
      "13th salary + bonus based on your performance.",
      "Opportunities to travel to Seattle, Washington, USA.",
    ],
    nameCompany: "Song Technologies LLC",
    company: 'International Digital Services Vietnam',
    textCompany:
      "An information services company with a focus on the live entertainment & ticketing industry.",
  },
  {
    name: "BackEnd Dev (Java) Up to $1500",
    img: "/img/Jobs/2.png",
    tech: ["FullStack"],
    address: "99 Hoan Kiem, Ha Tay, Ha Noi",
    location: "HA NOI",
    time: "3 hours ago",
    reasons: [
      "Attractive salary -Up to 2500$",
      "American-Based Company",
      "Premium health insurance.",
    ],
    description:
      "We are an American based company who looking to add Front-End Engineers to our team on a Full-Time basis. We are interested in developing software products with adapting latest technologies and methodologies of software development. Some of tools we are currently using: Cloud services, Kubernetes, ReactJS, Vuejs,  Nodejs, .Net core 2.0, .Net 4.7,  SQL Server 2017, and  RabbitMQ. ",
    experience: [
      "A bachelor’s degree in a technical discipline or equivalent experience in IT industry.",
      "High level of experience with ReactJS and MongoDB",
      "Knowledge of the .NET Framework and C# is beneficial.",
      "Have experience with any kind of front-end unit testing (jest, jasmine, mocha, karma)",
      "Comfortable working in a fast-paced environment",
      "Good teamwork spirit and logical thinking",
    ],
    why: [
      "Located in the center of HCMC",
      "Stable and long-term career path",
      "13th salary + bonus based on your performance.",
      "Opportunities to travel to Seattle, Washington, USA.",
    ],
    nameCompany: "Song Technologies LLC",
    company: 'International Digital Services Vietnam',
    textCompany:
      "An information services company with a focus on the live entertainment & ticketing industry.",
  },
  {
    name: "Frontend Developer (JavaScript, ReactJS)",
    img: "/img/Jobs/3.png",
    tech: ["JavaScript", "ReactJS"],
    address: "100 Vo Van Ngan, Q9, Ho Chi Minh",
    location: "HCM",
    time: "4 hours ago",
    reasons: [
      "Attractive salary -Up to 3500$",
      "American-Based Company",
      "Premium health insurance.",
    ],
    description:
      "We are an American based company who looking to add Front-End Engineers to our team on a Full-Time basis. We are interested in developing software products with adapting latest technologies and methodologies of software development. Some of tools we are currently using: Cloud services, Kubernetes, ReactJS, Vuejs,  Nodejs, .Net core 2.0, .Net 4.7,  SQL Server 2017, and  RabbitMQ. ",
    experience: [
      "A bachelor’s degree in a technical discipline or equivalent experience in IT industry.",
      "High level of experience with ReactJS and MongoDB",
      "Knowledge of the .NET Framework and C# is beneficial.",
      "Have experience with any kind of front-end unit testing (jest, jasmine, mocha, karma)",
      "Comfortable working in a fast-paced environment",
      "Good teamwork spirit and logical thinking",
    ],
    why: [
      "Located in the center of HCMC",
      "Stable and long-term career path",
      "13th salary + bonus based on your performance.",
      "Opportunities to travel to Seattle, Washington, USA.",
    ],
    nameCompany: "Song Technologies LLC",
    company: 'International Digital Services Vietnam',
    textCompany:
      "An information services company with a focus on the live entertainment & ticketing industry.",
  },
  {
    name: "5 FullStack Dev",
    img: "/img/Jobs/4.png",
    tech: ["Java", "NodeJS", "PHP"],
    address: "86-88 Dinh Tien Hoang, Tan Binh, Can Tho",
    location: "CAN THO",
    time: "5 hours ago",
    reasons: [
      "Attractive salary -Up to 1500$",
      "American-Based Company",
      "Premium health insurance.",
    ],
    description:
      "We are an American based company who looking to add Front-End Engineers to our team on a Full-Time basis. We are interested in developing software products with adapting latest technologies and methodologies of software development. Some of tools we are currently using: Cloud services, Kubernetes, ReactJS, Vuejs,  Nodejs, .Net core 2.0, .Net 4.7,  SQL Server 2017, and  RabbitMQ. ",
    experience: [
      "A bachelor’s degree in a technical discipline or equivalent experience in IT industry.",
      "High level of experience with ReactJS and MongoDB",
      "Knowledge of the .NET Framework and C# is beneficial.",
      "Have experience with any kind of front-end unit testing (jest, jasmine, mocha, karma)",
      "Comfortable working in a fast-paced environment",
      "Good teamwork spirit and logical thinking",
    ],
    why: [
      "Located in the center of HCMC",
      "Stable and long-term career path",
      "13th salary + bonus based on your performance.",
      "Opportunities to travel to Seattle, Washington, USA.",
    ],
    nameCompany: "Song Technologies LLC",
    company: 'International Digital Services Vietnam',
    textCompany:
      "An information services company with a focus on the live entertainment & ticketing industry.",
  },
  {
    name: "2 Dev Node js, Javascript",
    img: "/img/Jobs/5.png",
    tech: ["JavaScript", "C#", "ReactJS"],
    address: "86-88 Dinh Tien Hoang, Binh Thanh, Ho Chi Minh",
    location: "HCM",
    time: "5 hours ago",
    reasons: [
      "Attractive salary -Up to 1500$",
      "American-Based Company",
      "Premium health insurance.",
    ],
    description:
      "We are an American based company who looking to add Front-End Engineers to our team on a Full-Time basis. We are interested in developing software products with adapting latest technologies and methodologies of software development. Some of tools we are currently using: Cloud services, Kubernetes, ReactJS, Vuejs,  Nodejs, .Net core 2.0, .Net 4.7,  SQL Server 2017, and  RabbitMQ. ",
    experience: [
      "A bachelor’s degree in a technical discipline or equivalent experience in IT industry.",
      "High level of experience with ReactJS and MongoDB",
      "Knowledge of the .NET Framework and C# is beneficial.",
      "Have experience with any kind of front-end unit testing (jest, jasmine, mocha, karma)",
      "Comfortable working in a fast-paced environment",
      "Good teamwork spirit and logical thinking",
    ],
    why: [
      "Located in the center of HCMC",
      "Stable and long-term career path",
      "13th salary + bonus based on your performance.",
      "Opportunities to travel to Seattle, Washington, USA.",
    ],
    nameCompany: "Song Technologies LLC",
    company: 'International Digital Services Vietnam',
    textCompany:
      "An information services company with a focus on the live entertainment & ticketing industry.",
  },
  {
    name: "4 Design",
    img: "/img/Jobs/6.png",
    tech: ["Adobe"],
    address: "86-88 Dinh Tien Hoang, Binh Thanh, Can Tho",
    location: "CAN THO",
    time: "6 hours ago",
    reasons: [
      "Attractive salary -Up to 2500$",
      "American-Based Company",
      "Premium health insurance.",
    ],
    description:
      "We are an American based company who looking to add Front-End Engineers to our team on a Full-Time basis. We are interested in developing software products with adapting latest technologies and methodologies of software development. Some of tools we are currently using: Cloud services, Kubernetes, ReactJS, Vuejs,  Nodejs, .Net core 2.0, .Net 4.7,  SQL Server 2017, and  RabbitMQ. ",
    experience: [
      "A bachelor’s degree in a technical discipline or equivalent experience in IT industry.",
      "High level of experience with ReactJS and MongoDB",
      "Knowledge of the .NET Framework and C# is beneficial.",
      "Have experience with any kind of front-end unit testing (jest, jasmine, mocha, karma)",
      "Comfortable working in a fast-paced environment",
      "Good teamwork spirit and logical thinking",
    ],
    why: [
      "Located in the center of HCMC",
      "Stable and long-term career path",
      "13th salary + bonus based on your performance.",
      "Opportunities to travel to Seattle, Washington, USA.",
    ],
    nameCompany: "Song Technologies LLC",
    company: 'International Digital Services Vietnam',
    textCompany:
      "An information services company with a focus on the live entertainment & ticketing industry.",
  },
  {
    name: "1 Frontend Dev (HTML, CSS, JAVASCRIPT)",
    img: "/img/Jobs/7.png",
    tech: ["HTML", "CSS", "JAVASCRIPT"],
    address: "86-88 Dinh Tien Hoang, Binh Thanh, Ha Noi",
    location: "HA NOI",
    time: "7 hours ago",
    reasons: [
      "Attractive salary -Up to 1500$",
      "American-Based Company",
      "Premium health insurance.",
    ],
    description:
      "We are an American based company who looking to add Front-End Engineers to our team on a Full-Time basis. We are interested in developing software products with adapting latest technologies and methodologies of software development. Some of tools we are currently using: Cloud services, Kubernetes, ReactJS, Vuejs,  Nodejs, .Net core 2.0, .Net 4.7,  SQL Server 2017, and  RabbitMQ. ",
    experience: [
      "A bachelor’s degree in a technical discipline or equivalent experience in IT industry.",
      "High level of experience with ReactJS and MongoDB",
      "Knowledge of the .NET Framework and C# is beneficial.",
      "Have experience with any kind of front-end unit testing (jest, jasmine, mocha, karma)",
      "Comfortable working in a fast-paced environment",
      "Good teamwork spirit and logical thinking",
    ],
    why: [
      "Located in the center of HCMC",
      "Stable and long-term career path",
      "13th salary + bonus based on your performance.",
      "Opportunities to travel to Seattle, Washington, USA.",
    ],
    nameCompany: "Song Technologies LLC",
    company: 'International Digital Services Vietnam',
    textCompany:
      "An information services company with a focus on the live entertainment & ticketing industry.",
  },
];
